export default {
  header: 'Oups, vous êtes sur un navigateur non pris en charge.',
  message: "Pour une expérience utilisateur optimale, svp utilisez l'un des navigateurs suivants:",
};
